import { render } from "./ContactMemberEmailForm.vue?vue&type=template&id=7b52af2e"
import script from "./ContactMemberEmailForm.vue?vue&type=script&lang=js"
export * from "./ContactMemberEmailForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/musora-web-platform/musora-web-platform/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__